export class BarbaTransition {
	handleEnter(_data: any, _onAnimationComplete?: () => void) {
		throw new Error('Method must be overridden.');
	}

	handleLeave(_data: any, _onAnimationComplete?: () => void) {
		throw new Error('Method must be overridden.');
	}
}
